export const random = (min = 1, max) => {
    if (!max) {
        max = min;
        min = 0;
    }
    return Math.random() * (max - min) + min;
};
export const pickRandom = (of) => {
    return of[Math.floor(random(of.length))];
};
